import DatasetTable from "admin/components/DatasetTable";
import { DATASET_MANAGEMENT_PAGE_TITLE } from "admin/types/constants/page-titles";
import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription } from "~/components/ui/alert";
import useAppHeader from "~/contexts/header";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import { AdminPage } from "~/pages/manifold-nextgen/components/admin/AdminPage";

const Datasets = ({ isNextGen = false }: { isNextGen?: boolean }) => {
  useDocumentTitle(DATASET_MANAGEMENT_PAGE_TITLE);
  useAppHeader({ title: DATASET_MANAGEMENT_PAGE_TITLE });

  return (
    <AdminPage title="Dataset Admin" width={isNextGen ? "default" : "full"} fillHeight>
      <Alert variant="warning">
        <AlertTriangle />
        <AlertDescription>
          <p>
            You are now using your Dataset Admin privileges to manage datasets. This page allows you
            to escalate your own permissions on tables and files that you do not otherwise have
            access to. <b>Please use this power responsibly.</b>
          </p>
        </AlertDescription>
      </Alert>
      <DatasetTable isNextGen={isNextGen} />
    </AdminPage>
  );
};

export default Datasets;
